import Footer from "components/Footer/Footer";
import { Trans } from "@lingui/macro";
import { Link } from "react-router-dom";

export function SyntheticsFallbackPage() {
  return (
    <div className="page-layout">
      <div className="page-not-found-container">
        <div className="page-not-found">
          <h2>
            <Trans>This feature is not available</Trans>
          </h2>
          <p className="go-back">
            <Trans>MoneyX runs on V1 markets on BESC Hyperchain.</Trans>
            <br />
            <br />
            <Link className="App-cta" to="/v1">
              <Trans>Go to Trading</Trans>
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
